/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { ContentModuleModal, SortableList, ColorField, TextField } from '@molecules';

import Form from '../Form';
import noop from 'lodash/noop';
import { FORM_FIELD, IMAGE_INITS, IMAGES } from './constants';
import Item from './Item';
import ImageItem from './ImageItem';
import s from './styles.module.less';
import ImageForm from './ImageForm';
import useSetSingle from '@hooks/useSetSingle';

const LargeImageGallery = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues: initData,
  errors,
  isUltimateDesign,
}) => {
  const [form] = Form.useForm(FORM_FIELD);

  const initialValues = React.useMemo(() => form.deserialize(initData || IMAGE_INITS), [form, initData]); // initData || initData

  const [images, setImages] = React.useState(initialValues['images']); // TODO : find better definition

  const syncImages = React.useCallback(
    (_images) => {
      form.setFields([{ name: IMAGES.name, value: _images }]);
      setImages(_images);
    },
    [form, setImages],
  );

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      form.resetFields();
      hide();
    },
    [form, hide, onSubmit],
  );

  const handleCancel = React.useCallback(() => {
    form.resetFields();
    hide();
  }, [hide, form]);

  const handleAdd = React.useCallback((image) => syncImages([image, ...(form.getFieldValue(IMAGES.name) || [])]), [
    form,
    syncImages,
  ]);

  return (
    <ContentModuleModal
      visible={visible}
      title="Large image gallery"
      subtitle="Upload up to 30 images."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD LARGE IMAGE GALLERY'}
      onCancel={handleCancel}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <ImageForm onSubmit={handleAdd} className={s.addForm} isUltimateDesign={isUltimateDesign} />
      <SortableList
        style={NO_MARGIN_BOTTOM}
        label="Current images"
        onChange={syncImages}
        withPlaceholder
        value={images}
        withCount
        useEditable={useSetSingle}
      >
        {(value, { edit, isEdit, save, buttons }) =>
          isEdit ? (
            <ImageForm
              onSubmit={save}
              initialValues={value}
              buttons={buttons}
              isUltimateDesign={isUltimateDesign}
              isEdit
            />
          ) : (
            <ImageItem item={value} handleEdit={edit} isUltimateDesign={isUltimateDesign}>
              {value?.title}
            </ImageItem>
          )
        }
      </SortableList>
      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
      >
        <Form.List className={s.listItem} {...IMAGES} rules={isUltimateDesign ? [] : IMAGES.rules}>
          {noop}
        </Form.List>

        <ColorField {...FORM_FIELD.BACKGROUND_COLOR} />
        {!isUltimateDesign && <ColorField {...FORM_FIELD.TEXT_COLOR} />}
        <TextField {...FORM_FIELD.TITLE} />
        {isUltimateDesign && <TextField {...FORM_FIELD.SUBTITLE} style={NO_MARGIN_BOTTOM} />}
      </Form>
    </ContentModuleModal>
  );
};

LargeImageGallery.Item = Item;

export default LargeImageGallery;
